import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AutoComplete, Checkbox, Form, Input, Select, Tabs } from 'antd';
import Address from './address';
import Others from './others';
import Organization from './organization';
import TabPane from 'antd/es/tabs/TabPane';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { createUserData } from 'redux/slices/createUser';
import { FormHeader, FormItem, FormSubmitButtonConatainer, RowWrapper } from 'component/form_component/style';
import UserFormCheckbox from 'component/form_component/checkBox';
import { SweetSweetAlert } from 'component/sweetalert_components';
import TransferDataComponent from 'component/form_component/transferDataBox';
import { LeftArrowIcon } from 'assets/icons/AntDeisgn_icons/iconStyle';
import { BackButton, StyledButton } from 'component/button_components/button_general/ButtonGeneralStyle';
import {
  CreateContendwrap,
  CreateFormwrap,
  CreateStyleDiv,
  Createwrap,
} from 'component/create_ou_component/create_childOu_components/style';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';
import { getChildOuDropdown, getDomainContainers } from 'redux/slices/getChildOu';
import { getGroupsExceptUser, getGroupsOfUser } from 'redux/slices/usersGroupSlice';
import { autoGeneratePassword } from 'redux/slices/resetPassword';
import { debounce } from 'lodash';
import { getAttributes, getUpnSuggestions } from 'redux/slices/userSlice';
import { InputPatternRuleAD } from 'utils/input_pattern';
import Swal from 'sweetalert2';

export default function CreateUser() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const refreshUserTab = useRefreshUserTab();
  const [formTab1] = Form.useForm();
  const [formTab2] = Form.useForm();
  const [formTab3] = Form.useForm();
  const [formTab4] = Form.useForm();
  const [attributeForm] = Form.useForm();
  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState([]);
  const { upnSuggestions } = useSelector((state) => state.getUsers);
  const [initialRender, setInitialRender] = useState(true);
  const [removedGroups, setRemovedGroups] = useState([]);
  const [assignedGroups, setAssignedGroups] = useState([]);
  const [activeTab, setActiveTab] = useState('1');
  const selectedNode = useSelector((state) => state.selectedNode);
  const { childOuDropdown, domainContainers } = useSelector((state) => state.getChildOuData);
  const { loading } = useSelector((state) => state.createUserData);
  const adminOuName = useSelector((state) => state.ouTreeData.data);
  const { groupsExceptUser, groupsOfUser } = useSelector((state) => state.usersGroupSlice);
  const { mailUserCreation, domainMailUserCreation, overrideGlobalStatus } = useSelector((state) => state.settings);
  const canNotify = overrideGlobalStatus?.settings ? domainMailUserCreation ?? true : mailUserCreation ?? true;

  let mergedArray = [];
  let indexCounter = 1;
  mergedArray = [
    ...groupsOfUser.map((group) => ({
      title: group.groupName,
      dn: group.distinguishedName,
      groupAvailability: true,
      key: String(indexCounter++),
      primaryGroup: group.primaryGroup,
    })),
    ...groupsExceptUser.map((group) => ({
      title: group.groupName,
      dn: group.distinguishedName,
      groupAvailability: false,
      key: String(indexCounter++),
    })),
  ];

  const keysWithTrueGroupAvailability =
    mergedArray && mergedArray.filter((item) => item.groupAvailability).map((item) => item.key);

  const handleTransferChange = (addedData, direction, removedData) => {
    setAssignedGroups(addedData);
    setRemovedGroups(removedData);
  };
  const handleNameChange = () => {
    const firstName = formTab1.getFieldValue('givenName').trim();
    const initials = formTab1.getFieldValue('initials').trim();
    const lastName = formTab1.getFieldValue('surname').trim();
    const upn = formTab1.getFieldValue('userPrincipalName');

    const displayName = `${firstName || ''} ${initials ? `${initials}.` : ''} ${lastName || ''}`;
    formTab1.setFieldsValue({
      displayName: displayName && displayName.trim(),
      samAccountName: upn && upn.split('@')[0],
    });
  };

  useEffect(() => {
    dispatch(getUpnSuggestions(selectedNode.domainName ?? localStorage.getItem('domain')));
  }, []);

  const handleChange = debounce((value) => {
    setInputValue(value);
    if (value.includes('@')) {
      setOptions(upnSuggestions.map((option) => ({ value: option })));
    } else {
      setOptions([]);
    }
    const upn = formTab1.getFieldValue('userPrincipalName');
    formTab1.setFieldsValue({
      samAccountName: upn && upn.split('@')[0],
    });
  }, 300);

  const handleSelect = (value) => {
    const atIndex = inputValue.lastIndexOf('@');
    const newValue = inputValue.slice(0, atIndex + 1) + value;
    formTab1.setFieldsValue({
      userPrincipalName: newValue,
    });
  };

  useEffect(() => {
    let initialOuName = '';
    let fqdn = selectedNode.domainName ?? localStorage.getItem('domain');
    if (localStorage.getItem('role') === 'ouadmin') {
      initialOuName = adminOuName.dnName;
    } else {
      initialOuName =
        selectedNode.selectedNode && selectedNode.domainDn ? selectedNode.domainDn : localStorage.getItem('domainDn');
    }
    dispatch(
      getChildOuDropdown({
        fqdn: fqdn,
        ouName: initialOuName,
      })
    );
    dispatch(getDomainContainers(fqdn));
    dispatch(getAttributes(selectedNode.currentdomainId));
  }, [selectedNode]);

  useEffect(() => {
    if (selectedNode.selectedNode) {
      formTab1.setFieldsValue({
        ou: selectedNode.typeOfData === 'domain' ? null : selectedNode.selectedNode.dnName,
      });
    }
    if (!initialRender && location.pathname === '/create_user') {
      Navigate('/');
    } else {
      setInitialRender(false);
    }
  }, [selectedNode.selectedNode]);

  useEffect(() => {
    let initialOuName = '';
    if (localStorage.getItem('role') === 'ouadmin') {
      initialOuName = adminOuName.dnName;
    } else {
      initialOuName =
        selectedNode.selectedNode && selectedNode.domainDn ? selectedNode.domainDn : localStorage.getItem('domainDn');
    }
    formTab1.setFieldsValue({
      fqdn: selectedNode.domainName,
    });
    handleNameChange();
    dispatch(
      getGroupsExceptUser({
        fqdn: selectedNode.domainName || localStorage.getItem('domain'),
        userName: '',
        ouName: initialOuName,
      })
    );
    dispatch(
      getGroupsOfUser({
        fqdn: selectedNode.domainName || localStorage.getItem('domain'),
        userName: '',
      })
    );
  }, [selectedNode, formTab1]);

  const onFinish = async () => {
    let valuesTab1 = formTab1.getFieldsValue();
    const valuesTab2 = formTab2.getFieldsValue();
    const valuesTab3 = formTab3.getFieldsValue();
    const valuesTab4 = formTab4.getFieldsValue();
    const attributefields = attributeForm.getFieldsValue();
    let inputValue = valuesTab1.samAccountName;
    if (inputValue.match(InputPatternRuleAD.pattern)) {
      const result = await Swal.fire({
        icon: 'info',
        html: `The SAM AccountName ${inputValue} ${InputPatternRuleAD.message}`,
        showConfirmButton: true,
        confirmButtonColor: 'var(--bg-button-default-color)',
        showCancelButton: true,
        cancelButtonColor: 'green',
        width: '500px',
        heightAuto: false,
        reverseButtons: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        customClass: {
          icon: 'custom-swal-icon',
          title: 'custom-swal-title',
        },
      });
      if (result.isConfirmed) {
        inputValue = inputValue.replace(InputPatternRuleAD.pattern, '_');
        formTab1.setFieldsValue({
          samAccountName: inputValue,
        });
        valuesTab1 = formTab1.getFieldsValue();
      } else if (!result.isConfirmed) {
        return;
      }
    }
    if (valuesTab1.ou === selectedNode.selectedNode.name) {
      valuesTab1.ou = selectedNode.selectedNode.dnName;
    } else if (!valuesTab1.ou) {
      if (selectedNode.typeOfData !== 'ou') {
        valuesTab1.ou = selectedNode.selectedNode.dnName;
      }
    }
    const addGroupNames = [];
    const customAttributes = [attributefields];
    assignedGroups.forEach((item) => {
      if (!removedGroups.includes(item)) {
        addGroupNames.push(item.dn);
      }
    });
    valuesTab1.fqdn = selectedNode.domainName;
    const values = {
      createUser: [
        {
          ...valuesTab1,
          ...valuesTab2,
          ...valuesTab3,
          ...valuesTab4,
        },
      ],
      addGroupNames,
      customAttributes,
      domainId: selectedNode.currentdomainId,
    };
    try {
      const sweetAlert = await dispatch(createUserData(values));
      if (sweetAlert.payload && sweetAlert.payload.status === 200) {
        if (
          sweetAlert?.payload.data ===
          'New user has been created successfully and email could not be sent. Maildelivery not configured.'
        ) {
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        } else {
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        }
        Navigate('/');
      } else if (sweetAlert.payload && sweetAlert.payload.response.status === 400) {
        if (
          sweetAlert.payload.response.data === 'SamAccountName already exists.' ||
          sweetAlert.payload.response.data === 'UPN already exists.'
        ) {
          SweetSweetAlert({ sweetData: sweetAlert.payload.response.data, icon: 'warning', buttonColor: 'orange' });
        } else {
          SweetSweetAlert({ text: sweetAlert.payload.response.data, icon: 'error', buttonColor: 'red' });
        }
      } else {
        SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      }
    } catch (error) {
      SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
    }
    await refreshUserTab();
  };
  const generatePassword = async () => {
    const passwordValue = await dispatch(autoGeneratePassword(selectedNode.currentdomainId));
    if (passwordValue?.payload.status === 200) {
      return passwordValue.payload.data;
    }
  };
  const handleGeneratePassword = async () => {
    const newPassword = await generatePassword();
    formTab1.setFieldsValue({
      password: newPassword,
      confirmPassword: newPassword,
    });
  };

  const validatePasswordMatch = async (_, value) => {
    const newPassword = formTab1.getFieldValue('password');
    const confirmPassword = formTab1.getFieldValue('confirmPassword');
    if (confirmPassword) {
      if (newPassword && value === newPassword) {
        return Promise.resolve();
      } else {
        throw new Error('Passwords do not match');
      }
    }
  };
  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  return (
    <>
      <Createwrap className='af-outer-wrap af-createuser-outer-wrap'>
        <CreateStyleDiv className='af-wrap af-createuser-wrap'>
          <BackButton to='/' className='af-back-button af-createuser-back-button'>
            <LeftArrowIcon className='af-back-button-icon af-createuser-back-button-icon' /> Back
          </BackButton>
          <CreateContendwrap className='af-content-wrap af-createuser-content-wrap'>
            <CreateFormwrap className='af-form-wrap af-createuser-form-wrap'>
              {loading && <ModalOpenLoader />}
              <FormHeader className='af- -form-header af-createuser-form-header'>Create User</FormHeader>
              <Form
                className='af-form af-createuser-form'
                form={formTab1}
                layout='vertical'
                name='register'
                onFinish={onFinish}
                initialValues={{
                  displayName: '',
                  emailAddress: '',
                  samAccountName: '',
                  givenName: '',
                  surname: '',
                  password: '',
                  initials: '',
                  confirmPassword: '',
                  userPrincipalName: '',
                  ou: null,
                  fqdn: selectedNode.domainName,
                  notifyEmail: canNotify,
                }}
                size='large'
              >
                <Tabs
                  className='af-form-tab af-createuser-form-tab'
                  activeKey={activeTab}
                  defaultActiveKey='1'
                  onChange={handleTabChange}
                  tabPosition='top'
                  tabBarGutter={20}
                >
                  <TabPane
                    tab='Account'
                    key='1'
                    className='af-form-tab-tabpane af-createuser-form-tab-tabpane af-createuser-form-tab-tabpane_account'
                    forceRender={true}
                  >
                    <RowWrapper className='af-form-row-wraper af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap1'>
                      <FormItem
                        className='af-form-item af-createuser-form-item af-createuser-form-item-givenname'
                        key='givenName'
                        name='givenName'
                        label='First Name'
                        rules={[
                          {
                            required: true,
                            message: `Please Enter the First Name`,
                          },
                        ]}
                        style={{ flex: '40%' }}
                      >
                        <Input
                          onChange={handleNameChange}
                          className='af-form-input af-createuser-form-input af-createuser-form-input_givenname'
                        />
                      </FormItem>
                      <FormItem
                        key='initials'
                        name='initials'
                        label='Initial'
                        style={{ flex: '15%' }}
                        className='af-form-item af-createuser-form-item af-createuser-form-item-initials'
                      >
                        <Input
                          onChange={handleNameChange}
                          className='af-form-input af-createuser-form-input af-createuser-form-input_initials'
                        />
                      </FormItem>
                      <FormItem
                        key='surname'
                        name='surname'
                        label='Last Name'
                        style={{ flex: '40%' }}
                        className='af-form-item af-createuser-form-item af-createuser-form-item-surname'
                      >
                        <Input
                          onChange={handleNameChange}
                          className='af-form-input af-createuser-form-input af-createuser-form-input_surname'
                        />
                      </FormItem>
                    </RowWrapper>

                    <RowWrapper className='af-form-row-wraper af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap2'>
                      <FormItem
                        key='displayName'
                        name='displayName'
                        label='Display Name'
                        className='af-form-item af-createuser-form-item af-createuser-form-item-displayName'
                      >
                        <Input className='af-form-input af-createuser-form-input af-createuser-form-input_displayName' />
                      </FormItem>

                      <FormItem
                        key='emailAddress'
                        name='emailAddress'
                        label='E-mail'
                        rules={[
                          {
                            type: 'email',
                            message: `Please Enter the E-mail`,
                          },
                        ]}
                        className='af-form-item af-createuser-form-item af-createuser-form-item-emailAddress'
                      >
                        <Input className='af-form-input af-createuser-form-input af-createuser-form-input_emailAddress' />
                      </FormItem>
                    </RowWrapper>
                    <RowWrapper className='af-form-row-wraper af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap3'>
                      <FormItem
                        key='userPrincipalName'
                        name='userPrincipalName'
                        label='User Principal Name (UPN)'
                        rules={[
                          {
                            required: true,
                            message: `Please Enter the User Principal Name (UPN)`,
                          },
                          {
                            type: 'email',
                            message: `The input is not a valid UPN!`,
                          },
                        ]}
                        className='af-form-item af-createuser-form-item af-createuser-form-item-upn'
                      >
                        <AutoComplete
                          className='af-form-input af-createuser-form-input af-createuser-form-input_upn'
                          onChange={handleChange}
                          options={options}
                          onSelect={handleSelect}
                          defaultActiveFirstOption
                        />
                      </FormItem>
                      <FormItem
                        key='samAccountName'
                        name='samAccountName'
                        label='SAM Account Name'
                        rules={[
                          {
                            required: true,
                            message: `Please Enter the SAM Account Name`,
                          },
                        ]}
                        className='af-form-item af-createuser-form-item af-createuser-form-item-samName'
                      >
                        <Input className='af-form-input af-createuser-form-input af-createuser-form-input_samName' />
                      </FormItem>
                    </RowWrapper>
                    <RowWrapper className='af-form-row-wraper af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap4'>
                      <FormItem>
                        <FormItem
                          key='password'
                          name='password'
                          label='Password'
                          rules={[
                            {
                              required: true,
                              message: `Please Enter the Password`,
                            },
                          ]}
                          style={{ margin: '0px' }}
                          className='af-form-item af-createuser-form-item af-createuser-form-item-password'
                        >
                          <Input.Password className='af-form-input af-createuser-form-input af-createuser-form-input_password' />
                        </FormItem>
                        <Link onClick={handleGeneratePassword} className='af-createuser-form-generate'>
                          Generate
                        </Link>
                      </FormItem>
                      <FormItem
                        key='confirmPassword'
                        name='confirmPassword'
                        label='Confirm Password'
                        dependencies={['password']}
                        rules={[
                          {
                            required: true,
                            message: `Please Enter the Confirm Password`,
                          },
                          {
                            validator: validatePasswordMatch,
                          },
                        ]}
                        className='af-form-item af-createuser-form-item af-createuser-form-item-cnfm-password'
                      >
                        <Input.Password className='af-form-input af-createuser-form-input af-createuser-form-input_cnfm_password' />
                      </FormItem>
                    </RowWrapper>
                    {selectedNode.typeOfData !== 'builtinDomain' && (
                      <RowWrapper className='af-form-row-wraper af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap5'>
                        <FormItem
                          key='ou'
                          name='ou'
                          label='Ou'
                          className='oddFormItem af-form-item af-createuser-form-item af-createuser-form-item-ou'
                        >
                          <Select
                            allowClear
                            showSearch
                            placeholder='Select a Ou'
                            className='af-form-select af-createuser-form-select af-createuser-form-select_ou'
                          >
                            {domainContainers
                              .filter(
                                (container) =>
                                  typeof container === 'object' && container.distinguishedName.includes('CN=Users')
                              )
                              .map((container) => (
                                <Select.Option
                                  className='af-form-select-option af-createuser-form-select-option'
                                  key={container.distinguishedName}
                                  value={container.distinguishedName}
                                >
                                  {container.name} (Container)
                                </Select.Option>
                              ))}
                            {localStorage.getItem('role') === 'ouadmin' && (
                              <Select.Option
                                className='af-form-select-option af-createuser-form-select-option'
                                key={adminOuName.dnName}
                                value={adminOuName.dnName}
                              >
                                {adminOuName.name}
                              </Select.Option>
                            )}
                            {childOuDropdown.map((ou) => (
                              <Select.Option
                                className='af-form-select-option af-createuser-form-select-option'
                                key={ou.dnName}
                                value={ou.dnName}
                              >
                                {ou.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </FormItem>
                      </RowWrapper>
                    )}
                    <FormItem
                      label='Assign Group'
                      className='af-form-item af-createuser-form-item af-createuser-form-item-asign_group'
                    >
                      <TransferDataComponent
                        className='af-createuser-transferbox'
                        leftBoxData={mergedArray}
                        rightBoxData={keysWithTrueGroupAvailability}
                        onChange={handleTransferChange}
                        leftBoxTitle={'Available Group(s)'}
                        rightBoxTitle={'Assigned Group(s)'}
                      />
                    </FormItem>
                    <RowWrapper className='af-form-row-wraper af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap6'>
                      <UserFormCheckbox
                        className='af-createuser-checkbox af-createuser-checkbox_next_logon'
                        label={'User must change password on next login'}
                        value={'passwordAtNextLogon'}
                        form={formTab1}
                      />
                      <UserFormCheckbox
                        className='af-createuser-checkbox af-createuser-checkbox_cannot_change'
                        label={'User cannot change password'}
                        value={'userCannotChangePassword'}
                        form={formTab1}
                      />
                    </RowWrapper>
                    <RowWrapper className='af-createuser-form-row-wraper af-createuser-form-row-wraper-wrap7'>
                      <UserFormCheckbox
                        className='af-createuser-checkbox af-createuser-checkbox_never_expires'
                        label={'Password never Expires'}
                        value={'passwordNeverExpires'}
                        form={formTab1}
                      />
                      <UserFormCheckbox
                        className='af-createuser-checkbox af-createuser-checkbox_acc_disable'
                        label={'Account is disabled'}
                        value={'disable'}
                        form={formTab1}
                      />
                    </RowWrapper>
                  </TabPane>
                  <TabPane
                    tab='Address'
                    key='2'
                    className='af-form-tab-tabpane af-createuser-form-tab-tabpane af-createuser-form-tab-tabpane_address'
                    forceRender={true}
                  >
                    <Address formTab2={formTab2} className='af-createuser-form-address' />
                  </TabPane>
                  <TabPane
                    tab='Organization'
                    key='3'
                    className='af-form-tab-tabpane af-createuser-form-tab-tabpane af-createuser-form-tab-tabpane_organization'
                    forceRender={true}
                  >
                    <Organization formTab3={formTab3} className='af-createuser-form-organization' />
                  </TabPane>
                  <TabPane
                    tab='Others'
                    key='4'
                    className='af-form-tab-tabpane af-createuser-form-tab-tabpane af-createuser-form-tab-tabpane_others'
                    forceRender={true}
                  >
                    <Others formTab4={formTab4} attributeForm={attributeForm} className='af-createuser-form-others' />
                  </TabPane>
                </Tabs>
                <div
                  className='af-notifymail-wrapper af-createuser-notifymail-wrapper'
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <FormItem
                    name='notifyEmail'
                    label='notify'
                    className='hidden_label display-none af-form-item af-createuser-form-item af-createuser-form-item-notify'
                    valuePropName='checked'
                  >
                    <Checkbox
                      className='af-form-checkbox af-createuser-form-checkbox af-createuser-form-checkbox-notify_mail'
                      checked={canNotify}
                    >
                      Notify by email
                    </Checkbox>
                  </FormItem>

                  <FormSubmitButtonConatainer className='af-form-button-submit-wrapper af-createuser-form-button-submit-wrapper'>
                    <StyledButton
                      type='primary'
                      htmlType='submit'
                      className='af-form-button af-createuser-form-button af-createuser-form-button_submit'
                    >
                      Submit
                    </StyledButton>
                  </FormSubmitButtonConatainer>
                </div>
              </Form>
            </CreateFormwrap>
          </CreateContendwrap>
        </CreateStyleDiv>
      </Createwrap>
    </>
  );
}
